import React, { useState } from 'react';
import PasswordChecklist from "react-password-checklist";
import { TextField, Typography, InputAdornment, IconButton, Box } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import styled from '@emotion/styled';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import ValidIcon from '../img/valid-icon.svg';
import AddIcon from '../img/add-icon.svg';

export const ToggleButtdonWithIcon = ({ value, label, isActive, onClick }) => (
    <ToggleButton value={value} aria-label={label} onClick={onClick} sx={{
        borderRadius: '5px !important',
        border: isActive ? '3px solid #8140B7' : '3px solid #000',
        backgroundColor: '#000',
        fontSize: 20,
        lineHeight: 1.4,
        color: isActive ? '#fff' : '#828a99',
        textTransform: 'capitalize',
        minWidth: 300,
        minHeight: 80,
        '&:hover': {
            background: isActive ? '#5E2D89' : '#000',
            border: '3px solid #8140B7',
        },
        '&.Mui-selected,&.Mui-selected:hover,&.MuiToggleButtonGroup-lastButton': {
            background: '#000',
            border: isActive ? '3px solid #8140B7' : '3px solid #000',
            marginTop: 0,
        },
        '& .check-icon': {
            position: 'absolute',
            left: 20,
            top: '50%',
            transform: 'translateY(-50%)'
        },
    }}>
        {isActive && checkIcon}
        {label}
    </ToggleButton>
);

export const InputWrapStyles = (error) => ({
    background: '#000',
    fontSize: 16,
    width: '100%',
    borderRadius: '5px',
    border: '1px solid #000',
    opacity: 1,
    '& .MuiInputBase-root:before,& .MuiInputBase-root:hover:not(.Mui-disabled, .Mui-error):before': {
        //borderBottom: 'none',
        borderBottomColor: 'transparent'
    },

    '& .Mui-disabled .MuiOutlinedInput-notchedOutline': {
        borderColor: '#000 !important'
    },
    '& .Mui-disabled:not(label)': {
        color: '#fff !important',
        WebkitTextFillColor: '#fff !important',
        pointerEvents: 'none',
        background: 'transparent !important',
    },
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'transparent'
    },
    '& .MuiFilledInput-input, & .MuiOutlinedInput-input, & .MuiInputBase-input, & .MuiInputBase-input:-webkit-autofill': {
        paddingLeft: '20px',
        borderRadius: 'inherit',
        WebkitBoxShadow: '0 0 0 100px #000000 inset',
    },
    '& .MuiInputBase-inputMultiline': {
        height: '100% !important',
    },
    '& .MuiFilledInput-input:-webkit-autofill': {
        color: '#fff',
        WebkitBoxShadow: '0 0 0 100px #000 inset'
    },
    '& label.Mui-focused span br, & label.MuiFormLabel-filled span br': {
        display: 'none',
    },
    '& label.Mui-focused span span, & label.MuiFormLabel-filled span span': {
        display: 'none',
    },
    '&.is-error': {
        border: '1px solid #FC358A',
    },
    '&.is-valid': {
        border: '1px solid #12cac9',
    },
    '&.is-error .Mui-focused:after,&.is-valid .Mui-focused:after': {
        borderBottomColor: 'transparent',
        transform: 'scaleX(0)'
    },
    '&:before': {
        position: 'absolute',
        content: `url(${ValidIcon})`,
        right: '14px',
        top: '16px',
        opacity: 0,
        pointerEvents: 'none',
        width: '15px',
        height: '11px',
        zIndex: 5
    },
    '&.is-valid:before': {
        opacity: 1,
    },
    '& + .error-text': {
        display: 'none',
        fontSize: '12px'
    },
    '&.is-error + .error-text': {
        display: 'block',
    },
    '&.btn-add-social': {
        color: '#828a99',
        textTransform: 'none',
        minHeight: '56px',
        textAlign: 'left',
        justifyContent: 'flex-start',
        background: '#000',

    },
    '&.btn-add-social:hover': {
        backgroundColor: '#000',
        color: '#fff'

    },
    '&.btn-add-social:before': {
        width: 20,
        height: 20,
        right: 15,
        content: `url(${AddIcon})`,
        opacity: 1,
    },
    // select style MuiInputBase-root
    '&.MuiSelect .MuiSelect-select': {
        fontSize: 0,
        textAlign: 'left',
        paddingTop: '18px',
        paddingBottom: '15px',
    },
    '&.MuiSelect .MuiSelect-select svg': {
        display: 'none',
    },
    '&.MuiSelect .MuiListItemIcon-root': {
        verticalAlign: 'bottom',
        minWidth: '36px',
    },
    '&.MuiSelect .MuiInputBase-root': {
        backgroundColor: 'transparent',
    },
    '&.MuiSelect .MuiInputLabel-root': {
        fontSize: 16,
        lineHeight: 1.75,
        color: '#828a99',
        transform: 'translate(20px, 14px) scale(1)',
        pointerEvents: 'none'
    },
    '&.MuiSelect.is-active .MuiInputLabel-root': {
        transform: 'translate(20px, -7px) scale(0.75)'
    },
    '&.MuiSelect.is-active .MuiSelect-select': {
        fontSize: 16,
    },
    '&.MuiSelect.is-active .MuiSelect-select svg': {
        display: 'inline-block',
    },
    '&.MuiSelect .MuiSelect-icon': {
        right: 15,
    },
    // for disabled email
    '&.email-disabled': {
        background: 'transparent',
        '@media (min-width: 900px)': {
            display: 'flex',
            maxWidth: '298px'
        },
    },
});

export const InputStyles = {
    background: '#000',
    fontSize: 16,
    width: '100%',
    opacity: 1,
    borderRadius: '5px',
};

export const LabelStyles = {
    lineHeight: '1.76',
    color: '#828a99',
};


// password input
export const PasswordInputField = ({ id, label, onChange, variant = 'filled' }) => {
    const [showPassword, setShowPassword] = useState(false);

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    return (
        <TextField
            sx={InputWrapStyles}
            InputProps={{
                style: InputStyles,
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            sx={{
                                opacity: showPassword ? 1 : 0.5,
                            }}
                        >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                    </InputAdornment>
                ),
            }}
            InputLabelProps={{
                style: LabelStyles,
            }}
            id={id}
            label={label}
            // value={'1111ddD_'}
            type={showPassword ? 'text' : 'password'}
            autoComplete="new-password"
            variant={variant}
            onChange={onChange}
        />
    );
};

// PasswordChecklist
export const InlineStylesChecklist = {
    '& .valid-list': {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        flexDirection: {
            xs: 'row',
            md: 'column'
        },
        gap: '0 5px',
        textAlign: 'left'
    },
    '& .valid-list li.invalid .checklist-icon': {
        opacity: 0
    },
    '& .valid-list span': {
        fontWeight: 400,
        fontSize: '12px',
        lineHeight: 1.3,
        opacity: 1,
    },
};

export const StyledPasswordChecklist = ({ password, passwordAgain, setCurrentPasswordStatus }) => {
    return (
        <Box
            sx={InlineStylesChecklist}
        >
            <PasswordChecklist
                className="valid-list"
                rules={['minLength', 'specialChar', 'number', 'capital', 'match']}
                minLength={8}
                value={password}
                valueAgain={passwordAgain}
                onChange={setCurrentPasswordStatus}
                validColor={'#12cac9'}
                invalidColor={'#FC358A'}
                validTextColor={'#12cac9'}
                invalidTextColor={'#FC358A'}
                iconSize={14}
            />
        </Box>
    );
};

export const ValidateText = ({ textString }) => {
    return (
        <Typography
            className='error-text'
            sx={{
                width: '100%',
                padding: '4px 20px',
                color: '#FC358A'
            }}
            variant="caption"
            color="error">
            {textString}
        </Typography>
    );
};